import { getEventTypeGroupFromJson } from '../../events/data_types'

import dataTypes from './data_types_config.json'

export const americanFootballEventTypes = getEventTypeGroupFromJson(
  dataTypes,
  'American Football'
)
